export default {
  ALIPAY_PLUS_SESSION: 'ALIPAY_PLUS_SESSION',
  NEWPAY_SESSION: 'NEWPAY_SESSION',
  OPTTY_SESSION: 'OPTTY_SESSION',
  ADYEN_V2_KILLSWITCH: 'ADYEN_V2_KILLSWITCH',
};
